import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes, Navigate } from 'react-router-dom';

import RewardScreen from 'views/RewardScreen';
import ActivityContainer from 'views/ActivityContainer';
import SplashScreen from 'views/SplashScreen';
import AppSelection from 'views/AppSelection/components/AppSelection';
import Tester from 'views/Tester';
import ActivityRouteGuard from 'components/ActivityRouteGuard';

const routes = [
  {
    path: 'app-selection',
    Component: AppSelection
  },
  {
    path: ':module/splash',
    Component: SplashScreen
  },
  {
    path: ':module/reward-screen',
    Component: RewardScreen
  },
  {
    path: ':module/activity/:activityType',
    Component: ActivityContainer
  },
  ...(process.env.IS_TEST_ENVIRONMENT ? [{ path: 'tester', Component: Tester }] : []),
  ...[{ path: 'activity', Component: ActivityRouteGuard }]
];

const Router = () => (
  <Routes>
    {routes.map(({ path, Component }, idx) => (
      <Route key={idx} path={path} element={<Component />} />
    ))}
    <Route path="*" element={<Navigate to="app-selection" replace />} />
  </Routes>
);

routes.propTypes = {
  loggedIn: PropTypes.bool.isRequired
};

export default Router;
